import { api } from "@shared-server/api";
import { Avatar, AvatarFallback, AvatarImage } from "./shadcn/avatar";
import { Card, CardContent } from "./shadcn/card";
import { User } from "lucide-react";
import Link from "next/link";

interface ADUserCardProps {
  imagePath?: string | null;
  userPrincipalName: string;
}

export const ADUserCard = (props: ADUserCardProps) => {
  const userQuery = api.msGraph.user.useQuery(
    { userPrincipalName: props.userPrincipalName || "" },
    {
      enabled: !!props.userPrincipalName,
    },
  );

  // Shorthands
  const user = userQuery.data;
  if (!user) {
    return null;
  }

  return (
    <Card className="m-2 shadow-md text-foreground">
      <CardContent className="p-4">
        <div className="flex flex-row">
          {/* The fallback shows when there is no photo or it fails to load */}
          <Avatar className="mr-4 h-16 w-16">
            <AvatarImage
              src={props.imagePath ?? undefined}
              alt={user.displayName || "User Profile Image"}
            />
            <AvatarFallback className="border border-brand-ter-bluegray-300 bg-brand-ter-bluegray-200">
              <User size={28} aria-hidden />
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-1">
            <h2 className="mb-0 mt-2">{userQuery.data?.displayName}</h2>
            <div>{user?.jobTitle}</div>
            {user?.mail && (
              <Link
                className="hover:text-ter-green-500"
                href={`mailto:${user.mail.toLowerCase()}`}
              >
                {user.mail.toLowerCase()}
              </Link>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
